import React from 'react';

import { useCompany } from '@hooks/queries/useCompany';
import { makeMuiStyles, useCommonStyles, usePalette } from '@styles';
import { createStrings } from '@utils/local';
import { url } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'アカウント設定',
    needMembership: 'D2Dのご利用にはD2D MEMBERSへの申し込みが必要です。',
    applyNow: '今すぐD2D MEMBERSを申し込む',
    membershipProcessing: 'D2D MEMBERSを開設中です。しばらくお待ちください。',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.normalText,
    color: theme.palette.text.primary,
    fontWeight: 500,
    padding: '1rem 1rem',
    backgroundColor: theme.palette.grey['50'],
    flexGrow: 1,
    borderRadius: 8,
    marginBottom: 24,
    textAlign: 'center',
  },
}));

export const MembershipStatus: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const palette = usePalette();

  const company = useCompany();

  if (!company.isSuccess) return null;

  if (company.data.status === 'ドラフト') {
    return (
      <div className={classes.container}>
        {strings.needMembership}
        <a
          href={url('/utilities/MembershipForm/PolicyAgreement')}
          style={{ color: palette.warning.main }}
        >
          {strings.applyNow}
        </a>
      </div>
    );
  }

  if (company.data.status !== '手続き完了') {
    return <div className={classes.container}>{strings.membershipProcessing}</div>;
  }

  return null;
};
